import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';
import buildPath from '@/tsClient/utilities/buildPath';

type ThisApi = ApiDefinition['/quickbooks/{creatorId}/settings']['PUT'];
type Input = ThisApi['params'] & ThisApi['body'];

const updateQuickBooksSettings = async ({ creatorId, ...body }: Input): Promise<void> => {
  const path = buildPath<ThisApi>('/quickbooks/{creatorId}/settings', { creatorId });
  await noodleApiClient.put(path, body);
};

export default updateQuickBooksSettings;
